import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getUserRegisterGift} from "../../service";

type Gift = {
    id:string,
    createTime:number,
    actionType:number,
    actionTitle:string,
    coverUrl:string,
    actionSummary:string,
    startTime:string,
    endTime:string,
    statusCode:number
}

function RegisterGift(){

    const [info,setInfo] = useState<Gift>()

    useEffect(() => {
        getUserRegisterGift().then(res => {
            if(res.code === 1){
                setInfo(res.data)
            }
        })
    },[])

    if(!info){
        return null
    }

    return  <Link className="c-p-n" to={'/user/discount'}>
        <img src={info.coverUrl} alt=""/>
    </Link>
}

export default RegisterGift
